export default "__VITE_ASSET__cfiazcqe__"